// The viewer's auto-answer preference (interactions.json `autoAnswer`) as a generic game setting: the play controller owns
// the state and provides it here, so the prompt-bar switch and the game settings panel always show the same value.

import { createContext, useContext } from 'react';

export interface AutoAnswerSetting { label: string; enabled: boolean; setEnabled: (on: boolean) => void }

/** Plain statement of the trade-off, shown wherever the switch appears. */
export const AUTO_ANSWER_TRADEOFF = 'Others may infer you had no response when you pass quickly. Your own choice, kept in this browser.';

export const AutoAnswerSettingContext = createContext<AutoAnswerSetting | null>(null);
export const useAutoAnswerSetting = () => useContext(AutoAnswerSettingContext);
